import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onSetCustomerCenterIdName } from "../../../../features/mobile/settingSlice";
import Btn from "../../components/common/Btn";
import HeadCont from "../../components/common/HeadCont";
import TabCommon from "../../components/common/TabCommon";
import FAQ from "./contact/FAQ";
import UsageInquiry from "./contact/UsageInquiry";

const Contact = () => {
  const [tab, setTab] = useState("Inquiries");
  const tabs = ["Inquiries", "FAQ"];

  const dispatch = useDispatch();
  const { customerCenterQ, customerCenterId } = useSelector(
    (state) => state.setting
  );
  const navigate = useNavigate();

  return (
    <>
      <HeadCont
        rightIcon={"no icon"}
        transparent={"bg-back_ground"}
        title={"Contact Support"}
        onLeftAction={() => navigate("/mypage")}
      />
      <section className="mb-6 mt-14">
        <TabCommon tabs={tabs} setTab={setTab} tab={tab} />
        {tab === "Inquiries" ? (
          <div>
            <UsageInquiry
              customerCenterQ={customerCenterQ}
              customerCenterId={customerCenterId}
            />
          </div>
        ) : (
          <FAQ />
        )}
        {tab === "Inquiries" && (
          <div className="px-6 pt-4 maxW">
            <Btn
              bgColor={"bg-main"}
              textColor={"text-white font-semibold"}
              borderColor={"border border-main"}
              title={"Submit Inquiry"}
              active={"on"}
              onAction={() => {
                navigate("/contact/usageId");
                dispatch(onSetCustomerCenterIdName(null));
              }}
            />
          </div>
        )}
      </section>
    </>
  );
};

export default Contact;
